window.teaserbox = {
    /**
     * Compare Two Columns with Teaserboxes inside to set on same Height
     */
    initTwoColumnTeaserBoxes: function(){
        var $twoColGrids = document.querySelectorAll(".grid--twocolumn6-6");

        setTimeout(function (){
            $twoColGrids.forEach(function (item){
                var $cols = item.querySelectorAll(".medium-6");

                window.teaserbox.setTwoColumnTeaserHeight($cols);
                window.addEventListener('resize', function (){
                    if(window.innerWidth > 639) {
                        window.teaserbox.setTwoColumnTeaserHeight($cols);
                    }
                    else {
                        window.teaserbox.removeHeight($cols[0], $cols[1], null);
                    }
                });
            });
        },200);
    },

    /**
     * Two Column TeaserBox Set Height
     *
     * @param $cols
     */
    setTwoColumnTeaserHeight: function ($cols) {
        if($cols) {
            var $col1TeaserBoxContent = $cols[0].querySelector(".teaserbox .teaserbox__content"),
                $col2TeaserBoxContent = $cols[1].querySelector(".teaserbox .teaserbox__content"),
                $col1TeaserBoxText = $cols[0].querySelector(".teaserbox .teaserbox__text"),
                $col2TeaserBoxText = $cols[1].querySelector(".teaserbox .teaserbox__text");

            this.removeHeight($col1TeaserBoxContent, $col2TeaserBoxContent, null);
            if($col1TeaserBoxContent && $col2TeaserBoxContent) {
                window.articleCollection.equalHeight($col1TeaserBoxContent, $col2TeaserBoxContent);
            }

            this.removeHeight($col1TeaserBoxText, $col2TeaserBoxText, null);
            if($col1TeaserBoxText && $col2TeaserBoxText) {
                window.articleCollection.equalHeight($col1TeaserBoxText, $col2TeaserBoxText);
            }
        }
    },

    /**
     * Compare Three Columns with Teaserboxes inside to set on same Height
     */
    initThreeColumnTeaserBoxes: function(){
        var $threeColGrids = document.querySelectorAll(".grid--threecolumn");

        setTimeout(function () {
            $threeColGrids.forEach(function (item){
                var $cols = item.querySelectorAll(".medium-4");

                window.teaserbox.setThreeColumnTeaserHeight($cols);
                window.addEventListener('resize', function (){
                    if(window.innerWidth > 639) {
                        window.teaserbox.setThreeColumnTeaserHeight($cols);
                    }
                    else {
                        window.teaserbox.removeHeight($cols[0], $cols[1], $cols[2]);
                    }
                });
            });
        },200);
    },

    /**
     * Three Column TeaserBox Set Height
     *
     * @param $cols
     */
    setThreeColumnTeaserHeight: function ($cols) {
        if($cols) {
            var $col1TeaserBoxContent = $cols[0].querySelector(".teaserbox .teaserbox__content"),
                $col2TeaserBoxContent = $cols[1].querySelector(".teaserbox .teaserbox__content"),
                $col3TeaserBoxContent = $cols[2].querySelector(".teaserbox .teaserbox__content"),
                $col1TeaserBoxText = $cols[0].querySelector(".teaserbox .teaserbox__text"),
                $col2TeaserBoxText = $cols[1].querySelector(".teaserbox .teaserbox__text"),
                $col3TeaserBoxText = $cols[2].querySelector(".teaserbox .teaserbox__text");

            this.removeHeight($col1TeaserBoxContent, $col2TeaserBoxContent, $col3TeaserBoxContent);
            this.compareAndSetHeightToThreeColumnBoxes($col1TeaserBoxContent, $col2TeaserBoxContent, $col3TeaserBoxContent);

            this.removeHeight($col1TeaserBoxText, $col2TeaserBoxText, $col3TeaserBoxText);
            this.compareAndSetHeightToThreeColumnBoxes($col1TeaserBoxText, $col2TeaserBoxText, $col3TeaserBoxText);
        }
    },

    /**
     * Compare and set Height to the Column Elements
     *
     * @param $item1
     * @param $item2
     * @param $item3
     */
    compareAndSetHeightToThreeColumnBoxes: function ($item1, $item2, $item3) {
        if($item1.clientHeight >= $item2.clientHeight) {
            if($item1.clientHeight >= $item3.clientHeight) {
                $item2.style.height = $item1.clientHeight + 'px';
                $item3.style.height = $item1.clientHeight + 'px';
            }
        }
        else if($item2.clientHeight >= $item3.clientHeight) {
            $item1.style.height = $item2.clientHeight + 'px';
            $item3.style.height = $item2.clientHeight + 'px';
        }
        else {
            $item2.style.height = $item3.clientHeight + 'px';
            $item1.style.height = $item3.clientHeight + 'px';
        }
    },

    /**
     * Set Teaserbox Style Height to Zero
     *
     * @param $item1
     * @param $item2
     * @param $item3
     */
    removeHeight: function ($item1, $item2, $item3) {
        if($item1) {
            $item1.style.height = '';
        }
        if($item2) {
            $item2.style.height = '';
        }
        if($item3) {
            $item3.style.height = '';
        }
    }
}
